import { component$, type PropsOf } from "@builder.io/qwik";
import { LuCheck } from "@qwikest/icons/lucide";
import { cn } from "~/lib/cn";

export const FeatureCheck = component$((props: PropsOf<"svg">) => (
  <div
    class={cn(
      "bg-brand-100 flex h-5 w-5 shrink-0 grow-0 items-center justify-center gap-2 rounded-full",
      props.class,
    )}
  >
    <LuCheck {...props} class={cn("text-brand-700", props.class, "h-3 w-3")} />
  </div>
));
